import React from 'react';
import './DnaHelix.css';

const DnaHelix = () => {
  return (
    <div className="dna-container" data-testid="animated-background" aria-hidden="true">
      {/* Primary strand — right side */}
      <div className="dna-scene">
        <div className="dna-strand">
          {Array.from({ length: 20 }).map((_, i) => (
            <div key={i} className="dna-rung" style={{ '--i': i }}>
              <span className="dna-node dna-node-left" />
              <span className="dna-bridge" />
              <span className="dna-node dna-node-right" />
            </div>
          ))}
        </div>
      </div>

      {/* Secondary strand — left side, reversed */}
      <div className="dna-scene dna-scene-secondary">
        <div className="dna-strand dna-strand-reverse">
          {Array.from({ length: 16 }).map((_, i) => (
            <div key={i} className="dna-rung" style={{ '--i': i }}>
              <span className="dna-node dna-node-left" />
              <span className="dna-bridge" />
              <span className="dna-node dna-node-right" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DnaHelix;
